import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.3164 9.4L11.1247 8.20834C9.12474 9.73334 7.80807 12.0833 7.69141 14.75H9.35807C9.48307 12.5417 10.6164 10.6083 12.3164 9.4ZM22.6414 14.75H24.3081C24.1831 12.0833 22.8664 9.73334 20.8747 8.20834L19.6914 9.4C21.3747 10.6083 22.5164 12.5417 22.6414 14.75ZM20.9997 15.1667C20.9997 12.6083 19.6331 10.4667 17.2497 9.9V9.33334C17.2497 8.64167 16.6914 8.08334 15.9997 8.08334C15.3081 8.08334 14.7497 8.64167 14.7497 9.33334V9.9C12.3581 10.4667 10.9997 12.6 10.9997 15.1667V19.3333L9.33307 21V21.8333H22.6664V21L20.9997 19.3333V15.1667ZM15.9997 24.3333C16.1164 24.3333 16.2247 24.325 16.3331 24.3C16.8747 24.1833 17.3164 23.8167 17.5331 23.3167C17.6164 23.1167 17.6581 22.9 17.6581 22.6667H14.3247C14.3331 23.5833 15.0747 24.3333 15.9997 24.3333Z",
		fill: "#E25345"
	})
});
export default SvgAlert;
